import { render, staticRenderFns } from "./growthModelDeviceNumericalManagement.vue?vue&type=template&id=2d5705d8&scoped=true"
import script from "./growthModelDeviceNumericalManagement.vue?vue&type=script&lang=js"
export * from "./growthModelDeviceNumericalManagement.vue?vue&type=script&lang=js"
import style0 from "./growthModelDeviceNumericalManagement.vue?vue&type=style&index=0&id=2d5705d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5705d8",
  null
  
)

export default component.exports